// src/services/payablesService.js
// D-289 Phase 1c — loads everything the Payables (khaata) screens need.
//
// WHY THIS EXISTS
// The khaata maths lives in src/utils/khaata.js (pure, testable). This file
// only fetches the five collections that maths needs (purchase_bills added in P3d-5b-2), company-scoped, in one
// round trip, and hands them over. Nothing here writes to Firestore —
// payments are written only by src/services/paymentService.js.

import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { buildKhaatas } from "../utils/khaata";

const byId = (snap) =>
  Object.fromEntries(snap.docs.map((d) => [d.id, { id: d.id, ...d.data() }]));

// Returns every vendor / subcontractor that has at least one bill or payment,
// each with: name, bills (with Paid / Partly / Due), payments, billed,
// settled, paid_cash, tds_total, due, advance. Biggest due first.
export async function loadKhaatas(company_id) {
  if (!company_id) throw new Error("Company not loaded.");

  const [ledgerSnap, vendorSnap, subSnap, logSnap, billSnap] = await Promise.all([
    getDocs(query(collection(db, "financial_transactions"),  where("company_id", "==", company_id))),
    getDocs(query(collection(db, "vendors"),                 where("company_id", "==", company_id))),
    getDocs(query(collection(db, "subcontractors"),          where("company_id", "==", company_id))),
    getDocs(query(collection(db, "subcontractor_work_logs"), where("company_id", "==", company_id))),
    // P3d-5b-2: the vendor's bills - bill type / invoice no come from the bill doc (a proforma is upgraded later; the payable row is never edited)
    getDocs(query(collection(db, "purchase_bills"),          where("company_id", "==", company_id))),
  ]);

  return buildKhaatas({
    ledgerRows:         ledgerSnap.docs.map((d) => ({ id: d.id, ...d.data() })),
    vendorsById:        byId(vendorSnap),
    subcontractorsById: byId(subSnap),
    logsById:           byId(logSnap),
    purchaseBillsById:  byId(billSnap),
  });
}